/* MoRetro Studio V20 — Workflow / Source de vérité
   But : centraliser les écritures Firestore sans toucher à la partie imprimantes.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const STATUS_ORDER = [
    "new","progress","quoted","accepted","paid","printing","finishing","ready","shipped","done","archived"
  ];

  function nowIso(){
    return new Date().toISOString();
  }

  function projectRef(projectOrId){
    const id = typeof projectOrId === "string" ? projectOrId : projectOrId?.id;
    if(!id || !MTS.state?.db) throw new Error("Projet ou base Firestore indisponible.");
    return MTS.state.db.collection("custom_requests").doc(id);
  }

  function normalizeMoney(value){
    const n = Number(String(value ?? "").replace(",", ".").replace(/[^\d.]/g, ""));
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  function quotePrice(project = {}){
    const q = project.quote || {};
    const aq = project.autoQuote?.quote || {};
    return normalizeMoney(q.final || q.total || q.price || aq.final || aq.suggested || project.finalPrice || project.quoteTotal);
  }

  function quoteData(project = {}){
    const price = quotePrice(project);
    const auto = project.autoQuote || null;
    const q = project.quote || {};
    const printHours = Number(auto?.quote?.printHours || q.printHours || 0);
    const printMinutes = Math.round(printHours * 60);
    const printerName = auto?.analysis?.metadata?.printer || auto?.settings?.printer || project.printerName || "";

    return {
      price,
      printerName,
      printMinutes,
      quoteNumber: auto?.quoteNumber || q.quoteNumber || "",
      autoQuote: auto
    };
  }

  function historyEntry(type, label, extra = {}){
    return {
      type,
      label,
      date: nowIso(),
      ...extra
    };
  }

  function documentRecord(type, data = {}){
    const idPrefix = type || "doc";
    return {
      id: `${idPrefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      type,
      documentType: data.documentType || type,
      category: data.category || "documents",
      icon: data.icon || "📄",
      name: data.name || data.title || "Document",
      title: data.title || data.name || "Document",
      description: data.description || "",
      url: data.url || "",
      amount: data.amount || "",
      shopifyRef: data.shopifyRef || "",
      createdAt: nowIso(),
      ...data
    };
  }

  async function saveQuote(project, autoQuote){
    const q = autoQuote?.quote || project.autoQuote?.quote || project.quote || {};
    const price = normalizeMoney(q.final || q.suggested || q.total || q.price || project.finalPrice || project.quoteTotal);
    const printMinutes = Math.round(Number(q.printHours || 0) * 60);
    const printerName = autoQuote?.analysis?.metadata?.printer || autoQuote?.settings?.printer || project.printerName || "";
    const quoteNumber = autoQuote?.quoteNumber || project.quote?.quoteNumber || `DEV-${new Date().toISOString().slice(0,10).replaceAll("-","")}`;

    const quoteDoc = documentRecord("quote_pdf", {
      documentType: "quote_pdf",
      category: "documents",
      icon: "📄",
      name: `Devis PDF ${quoteNumber}`,
      title: "Devis PDF",
      description: "Devis atelier enregistré depuis MoRetro Studio",
      amount: price || "",
      price: price || "",
      quoteNumber
    });

    const update = {
      autoQuote: autoQuote || project.autoQuote || null,
      finalPrice: price || project.finalPrice || 0,
      quoteTotal: price || project.quoteTotal || 0,
      printerName,
      printEstimatedMinutes: printMinutes,
      quote:{
        ...(project.quote || {}),
        price,
        total: price,
        final: price,
        quoteNumber,
        updatedAt: nowIso()
      },
      files: firebase.firestore.FieldValue.arrayUnion(quoteDoc),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      history: firebase.firestore.FieldValue.arrayUnion(historyEntry("quote_saved", "Devis atelier enregistré"))
    };

    await projectRef(project).set(update, { merge:true });

    const currentFiles = Array.isArray(project.files) ? project.files : [];
    const already = currentFiles.some(f => f.type === "quote_pdf" && f.quoteNumber === quoteNumber);
    Object.assign(project, update, {
      updatedAt: nowIso(),
      files: already ? currentFiles : [...currentFiles, quoteDoc]
    });

    return update;
  }

  async function addDocument(project, doc, label = "Document ajouté"){
    const record = documentRecord(doc.type || doc.documentType || "document", doc);
    await projectRef(project).set({
      files: firebase.firestore.FieldValue.arrayUnion(record),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      history: firebase.firestore.FieldValue.arrayUnion(historyEntry("document_added", label, { documentId: record.id }))
    }, { merge:true });

    project.files = Array.isArray(project.files) ? [...project.files, record] : [record];
    return record;
  }

  async function setStatus(project, status, label){
    if(!STATUS_ORDER.includes(status)) throw new Error("Statut invalide : " + status);

    await projectRef(project).set({
      status,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      history: firebase.firestore.FieldValue.arrayUnion(historyEntry("status_changed", label || ("Statut : " + MTS.statusLabel(status))))
    }, { merge:true });

    project.status = status;
    project.updatedAt = nowIso();
    return status;
  }

  function refreshProject(project){
    try{
      if(MTS.Projects?.renderDetail) MTS.Projects.renderDetail(project);
      if(MTS.Projects?.renderList) MTS.Projects.renderList();
      if(MTS.App?.renderAll) MTS.App.renderAll();
    }catch(err){
      console.warn("Rafraîchissement projet impossible :", err);
    }
  }

  MTS.Workflow = {
    nowIso,
    quotePrice,
    quoteData,
    historyEntry,
    documentRecord,
    saveQuote,
    addDocument,
    setStatus,
    refreshProject
  };
})(window.MTS);
